<template>
    <div :class="containerClass" @click="onDocumentClick">
        <AppTopBar
            v-if="!isCredenciamentoRoute"
            :topbarMenuActive="topbarMenuActive"
            :activeTopbarItem="activeTopbarItem"
            @menubutton-click="onMenuButtonClick"
            @topbar-menubutton-click="onTopbarMenuButtonClick"
            @topbar-item-click="onTopbarItemClick"
        />

        <transition name="layout-menu-container">
            <SebraeSidebar v-show="isMenuVisible()" @click="onMenuClick">
                <AppMenu
                    :key="`menu-${sidebarEnterKey}`"
                    :model="menu"
                    layoutMode="static"
                    :active="menuActive"
                    :mobileMenuActive="staticMenuMobileActive"
                    @menuitem-click="onMenuItemClick"
                    @root-menuitem-click="onRootMenuItemClick"
                />
            </SebraeSidebar>
        </transition>

        <div class="layout-main">
            <div class="layout-content" :class="{ 'layout-content--credenciamento': isCredenciamentoRoute }">
                <SebraeResultState
                    v-if="httpFeedbackAtivo"
                    :variant="httpFeedback.variant"
                    :title="httpFeedback.title"
                    :description="httpFeedback.description"
                    :code="httpFeedback.status || undefined"
                    @primary-action="onHttpFeedbackPrimary"
                    @secondary-action="onHttpFeedbackSecondary"
                >
                    <SebraeAlert
                        v-if="httpFeedback.messages.length > 1"
                        variant="danger"
                        :message="httpFeedback.messages.slice(1).join(' ')"
                    />
                </SebraeResultState>
                <router-view v-else />
            </div>

            <AppFooter v-if="!isCredenciamentoRoute" />
        </div>

        <div class="layout-content-mask"></div>
    </div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
import AppFooter from './AppFooter.vue';
import EventBus from './event-bus';
import appMenu from './app/menu.js';
import { LAYOUT_DESKTOP_MIN_WIDTH_PX } from './shared/layout/constants';

export default {
    data() {
        return {
            staticMenuMobileActive: false,
            staticMenuDesktopInactive: false,
            topbarMenuActive: false,
            activeTopbarItem: null,
            menuActive: false,
            menuClick: false,
            topbarItemClick: false,
            menu: [...appMenu],
            sidebarEnterKey: 0,
        };
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$store.dispatch('clearHttpFeedback');
        },
        '$store.getters.menuVisible'() {
            this.onMenuButtonClick();
        },
        menuVisivel(visivel, anterior) {
            if (visivel && anterior === false) {
                this.sidebarEnterKey += 1;
            }
        },
        staticMenuMobileActive(ativo, anterior) {
            if (ativo && anterior === false) {
                this.sidebarEnterKey += 1;
            }
        },
    },
    computed: {
        containerClass() {
            return [
                'layout-wrapper',
                'layout-static',
                'layout-menu-dark',
                {
                    'layout-wrapper--home': this.isHomeRoute,
                    'layout-wrapper--credenciamento': this.isCredenciamentoRoute,
                    'layout-mobile-active': this.staticMenuMobileActive,
                    'layout-static-inactive': this.staticMenuDesktopInactive,
                    'p-input-filled': this.$primevue.config.inputStyle === 'filled',
                    'p-ripple-disabled': this.$primevue.config.ripple === false,
                },
            ];
        },

        isHomeRoute() {
            return this.$route.name === 'DashBoard';
        },

        isCredenciamentoRoute() {
            return this.$route.name === 'Checkins_Credenciamento';
        },

        menuVisivel() {
            return this.isMenuVisible();
        },

        httpFeedbackAtivo() {
            return this.$store.getters.httpFeedbackActive;
        },

        httpFeedback() {
            return this.$store.getters.httpFeedback;
        },
    },
    methods: {
        onDocumentClick() {
            if (!this.topbarItemClick) {
                this.activeTopbarItem = null;
                this.topbarMenuActive = false;
            }

            if (!this.menuClick) {
                if (this.staticMenuMobileActive) {
                    this.hideMobileMenu();
                }

                EventBus.emit('reset-active-index');
                this.unblockBodyScroll();
            }

            this.topbarItemClick = false;
            this.menuClick = false;
        },
        onMenuButtonClick(event) {
            this.menuClick = true;
            this.topbarMenuActive = false;

            if (this.isDesktop()) {
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
                if (this.staticMenuMobileActive) {
                    this.blockBodyScroll();
                } else {
                    this.unblockBodyScroll();
                }
            }

            event?.preventDefault();
        },
        onTopbarMenuButtonClick(event) {
            this.topbarItemClick = true;
            this.topbarMenuActive = !this.topbarMenuActive;
            this.hideMobileMenu();
            event.preventDefault();
        },
        onTopbarItemClick(event) {
            this.topbarItemClick = true;

            if (this.activeTopbarItem === event.item) {
                this.activeTopbarItem = null;
            } else {
                this.activeTopbarItem = event.item;
            }

            event.originalEvent.preventDefault();
        },
        onMenuClick() {
            this.menuClick = true;
        },
        blockBodyScroll() {
            document.body.classList.add('blocked-scroll');
        },
        unblockBodyScroll() {
            document.body.classList.remove('blocked-scroll');
        },
        hideMobileMenu() {
            this.staticMenuMobileActive = false;
        },
        onMenuItemClick(event) {
            if (!event.item.items) {
                EventBus.emit('reset-active-index');
                this.hideMobileMenu();
            }
        },
        onRootMenuItemClick() {
            this.menuActive = !this.menuActive;
        },
        isDesktop() {
            return window.innerWidth >= LAYOUT_DESKTOP_MIN_WIDTH_PX;
        },
        isMenuVisible() {
            if (this.isDesktop()) {
                return !this.staticMenuDesktopInactive;
            }

            return true;
        },

        onHttpFeedbackPrimary() {
            const variant = this.httpFeedback.variant;
            const voltarVariants = ['forbidden', 'not-found'];

            this.$store.dispatch('clearHttpFeedback');

            if (voltarVariants.includes(variant)) {
                if (window.history.length > 1) {
                    this.$router.back();
                    return;
                }

                this.$router.push({ path: '/' });
                return;
            }

            this.$router.replace({
                path: this.$route.fullPath,
                query: { ...this.$route.query, _retry: Date.now() },
            });
        },

        onHttpFeedbackSecondary() {
            this.$store.dispatch('clearHttpFeedback');
            this.$router.push({ path: '/' });
        },
    },
    components: {
        AppTopBar,
        AppMenu,
        AppFooter,
    },
};
</script>
